import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  root: {
    width: '100%'
  },
  tableWrap: {
    maxHeight: 'calc(100vh - 10rem)',
    overflow: 'auto',
    '@media all and (min-width: 620px) and (max-width: 1090px)': {
      maxHeight: 'calc(100vh - 18rem)',
      marginBottom: '1rem'
    },
    '@media all and (max-width: 620px)': {
      maxHeight: 'calc(100vh - 22rem)',
      marginBottom: '1rem'
    }
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse'
  },
  tableBody: { background: '#f9f9f9' }
}))

export default useStyles
